import { BaseInterior } from './BaseInterior';
import { CasinoLobby } from './casino/CasinoLobby';
import { BlackjackGame } from './casino/BlackjackGame';
import { SlotsGame } from './casino/SlotsGame';
import { RouletteGame } from './casino/RouletteGame';
import { CrapsGame } from './casino/CrapsGame';
import { CasinoManagement } from './casino/CasinoManagement';

type CasinoView = 'LOBBY' | 'SLOTS' | 'BLACKJACK' | 'ROULETTE' | 'CRAPS' | 'MANAGEMENT';

export class CasinoInterior extends BaseInterior {
  private currentView: CasinoView = 'LOBBY';
  private blackjackGame: BlackjackGame | null = null;
  private slotsGame: SlotsGame | null = null;
  private rouletteGame: RouletteGame | null = null;
  private crapsGame: CrapsGame | null = null;
  private casinoManagement: CasinoManagement | null = null;

  render(): void {
    console.log(`[CASINO] Initial render, currentView=${this.currentView}`);
    this.renderCurrentView();
  }

  bindEvents(): void {
    // Events are bound per-view in renderCurrentView
  }

  private renderCurrentView(): void {
    console.log(`[CASINO] renderCurrentView called, view=${this.currentView}`);
    // Clean up sub-views if switching away
    if (this.blackjackGame) {
      this.blackjackGame.destroy();
      this.blackjackGame = null;
    }
    if (this.slotsGame) {
      this.slotsGame.destroy();
      this.slotsGame = null;
    }
    if (this.rouletteGame) {
      this.rouletteGame.destroy();
      this.rouletteGame = null;
    }
    if (this.crapsGame) {
      this.crapsGame.destroy();
      this.crapsGame = null;
    }
    if (this.casinoManagement) {
      this.casinoManagement.destroy();
      this.casinoManagement = null;
    }

    // Clear everything
    this.destroy();
    this.graphics = this.scene.add.graphics();
    this.elements = [];

    this.drawRoom(0x2a1a3a, 0x4a2a5a); // dark purple casino room
    this.addExitButton();

    switch (this.currentView) {
      case 'LOBBY':
        this.renderLobby();
        break;
      case 'BLACKJACK':
        this.renderBlackjack();
        break;
      case 'SLOTS':
        this.renderSlots();
        break;
      case 'ROULETTE':
        this.renderRoulette();
        break;
      case 'CRAPS':
        this.renderCraps();
        break;
      case 'MANAGEMENT':
        this.renderManagement();
        break;
    }
  }

  private renderLobby(): void {
    const lobby = new CasinoLobby(
      this,
      this.scene,
      this.graphics,
      this.building,
      this.stateData,
      (view: CasinoView) => this.switchView(view),
    );
    lobby.render();
  }

  private renderBlackjack(): void {
    this.blackjackGame = new BlackjackGame(
      this.scene,
      this.graphics,
      this.building,
      this.stateData,
      () => this.switchView('LOBBY'),
    );
    this.blackjackGame.render();
  }

  private renderSlots(): void {
    this.addTitle('Machines a sous');
    this.addButton(100, 80, '< Retour', '#7b2fbe', () => this.switchView('LOBBY'));

    this.slotsGame = new SlotsGame(
      this.scene,
      this.graphics,
      this.building,
      this.stateData,
      () => this.switchView('LOBBY'),
    );
    this.slotsGame.render();
  }

  private renderRoulette(): void {
    this.addTitle('Roulette');
    this.addButton(100, 80, '< Retour', '#7b2fbe', () => this.switchView('LOBBY'));

    this.rouletteGame = new RouletteGame(
      this.scene,
      this.graphics,
      this.building,
      this.stateData,
      () => this.switchView('LOBBY'),
    );
    this.rouletteGame.render();
  }

  private renderCraps(): void {
    this.addTitle('Craps');
    this.addButton(100, 80, '< Retour', '#7b2fbe', () => this.switchView('LOBBY'));

    this.crapsGame = new CrapsGame(
      this.scene,
      this.graphics,
      this.building,
      this.stateData,
      () => this.switchView('LOBBY'),
    );
    this.crapsGame.render();
  }

  private renderManagement(): void {
    this.addTitle('Gestion du Casino');
    this.addButton(100, 80, '< Retour', '#7b2fbe', () => this.switchView('LOBBY'));

    this.casinoManagement = new CasinoManagement(
      this.scene,
      this.graphics,
      this.building,
      this.stateData,
      () => this.switchView('LOBBY'),
    );
    this.casinoManagement.render();
  }

  private switchView(view: CasinoView): void {
    console.log(`[CASINO] Switching to view: ${view}`);
    this.currentView = view;
    this.renderCurrentView();
  }
}
